/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['./matrixFactory', './singleRequestServiceFactory', 'endpoints', './batchRequestServiceFactory',
    'services/routing/routingParameters', 'services/routing/reachableRangeParameters',
    './request/contentTypeConfigurer'],
function(matrixFactory, singleRequestServiceFactory, endpoints, batchRequestServiceFactory, routingParameters,
    reachableRangeParameters, contentTypeConfigurer) {
    'use strict';

    var maxNoOfElementsInBatchRequest = 100,
        routingFields = contentTypeConfigurer.setField(routingParameters()),
        reachableRangeFields = contentTypeConfigurer.setField(reachableRangeParameters());

    return {
        calculateRoute: singleRequestServiceFactory(routingFields, endpoints.routing),

        calculateReachableRange: singleRequestServiceFactory(reachableRangeFields,
            endpoints.reachableRange),

        batch: batchRequestServiceFactory(maxNoOfElementsInBatchRequest, routingFields,
            { batchSync: endpoints.batchSyncRouting, batch: endpoints.batchRouting,
              single: endpoints.batchRoutingQuery}),

        batchReachableRange: batchRequestServiceFactory(maxNoOfElementsInBatchRequest, reachableRangeFields,
            { batchSync: endpoints.batchSyncRouting, batch: endpoints.batchRouting,
              single: endpoints.batchReachableRangeQuery}),

        matrix: matrixFactory(maxNoOfElementsInBatchRequest)
    };
});



// WEBPACK FOOTER //
// ./rest/routing/routing.js